/** サーバ時刻とクライアント時刻の差（ms）。SLA 残り時間の計算に使う（改善 D）。
 *  最初のレスポンスの `Date` ヘッダで一度だけ同期し、以後はローカル時計で進める
 *  （毎回同期すると端末のスリープ復帰時などに表示が飛ぶため）。 */
let serverOffsetMs = 0;
let serverOffsetSynced = false;

function syncServerOffset(res: Response): void {
  if (serverOffsetSynced) return;
  const header = res.headers.get("Date");
  if (!header) return;
  const t = new Date(header).getTime();
  if (!Number.isFinite(t)) return;
  serverOffsetMs = t - Date.now();
  serverOffsetSynced = true;
}

/** サーバ時刻に補正した現在時刻（ms）。 */
export function serverNow(): number {
  return Date.now() + serverOffsetMs;
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`/api${path}`, {
    ...init,
    headers: { "Content-Type": "application/json", ...(init?.headers || {}) },
  });
  syncServerOffset(res);
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status} ${text}`);
  }
  return (await res.json()) as T;
}

/** 502/503（デプロイ直後の一瞬など）を数回リトライする。プレビュー取得向け。 */
export async function apiWithRetry<T>(
  path: string,
  init?: RequestInit,
  retries = 2,
): Promise<T> {
  let lastErr: unknown;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      return await api<T>(path, init);
    } catch (e) {
      lastErr = e;
      const msg = e instanceof Error ? e.message : String(e);
      if (attempt < retries && /\bHTTP 50[23]\b/.test(msg)) {
        await new Promise((r) => window.setTimeout(r, 600 * (attempt + 1)));
        continue;
      }
      throw e;
    }
  }
  throw lastErr;
}
